// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import AccordionState from "@store/Framework/Store/Starter/Components/Accordion/AccordionState";
import { AccordionAnchorModel } from "@store/Framework/Store/Starter/Components/Accordion/AccordionTypes";
import { CreateAccordionAnchorParameter } from "@store/Framework/Store/Starter/Components/Accordion/Handlers/CreateAccordionAnchor";
import { RemoveAccordionAnchorParameter } from "@store/Framework/Store/Starter/Components/Accordion/Handlers/RemoveAccordionAnchor";
import { SetIsAccordionOpenHandlerProps } from "@store/Framework/Store/Starter/Components/Accordion/Handlers/SetIsAccordionOpen";
import { Draft } from "immer";

const initialState: AccordionState = {
    anchors: [],
};

const actions = {
    "Starter/Components/Accordion/CreateAccordionAnchor": (
        draft: Draft<AccordionState>,
        action: CreateAccordionAnchorParameter,
    ) => {
        const anchor: AccordionAnchorModel = {
            id: action.id,
            isOpen: action.isOpen,
        };
        draft.anchors = [...draft.anchors, anchor];
    },
    "Starter/Components/Accordion/SetIsAccordionOpen": (
        draft: Draft<AccordionState>,
        action: SetIsAccordionOpenHandlerProps,
    ) => {
        draft.anchors = action.anchors;
    },
    "Starter/Components/Accordion/RemoveAccordionAnchor": (
        draft: Draft<AccordionState>,
        action: RemoveAccordionAnchorParameter,
    ) => {
        draft.anchors = draft.anchors.filter(x => x.id !== action.id);
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type AccordionActions = Parameters<typeof reducer>[1];
export default reducer;
